import { makeRequest } from './widget-facade';
import athenaConfig from '../config';
import AmplitudeUtils from './amplitude-utils';

export async function skipFido2Enrollment(stateHandle: string, username: string): Promise<void> {
  try {
    await makeRequest({
      url: `${athenaConfig.fido2EnforcementLambdaBaseUrl}/skip-enrollment`,
      method: 'POST',
      args: { stateHandle, username },
      headers: { 'Content-Type': 'application/json' },
    });
  }
  catch (error: any) {
    AmplitudeUtils.logCustomEvent('Fido2SkipEnrollment::Error', {});
  }
}
